module.exports = __webpack_public_path__ + "static/media/mindfulness-for-sleep-large@3x.6066d246.png";